import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { Suspense } from 'react'
import { WorkspacesBreadcrumbs } from '../WorspacesBreadcrumbs'
import { DataTableLoading } from '@/catalog-apps/components/component-library/DataTableComponent/DataTableLoading'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { useRestClient } from '@/contexts/QueryProvider'
import { useCurrentWorkspace } from '../useCurrentWorkspace'
import { WorkspaceFilesFilters } from './WorkspaceFilesTable/WorkspaceFilesFilters'
import { workspaceFilesColumns } from './WorkspaceFilesTable/workspaceFilesColumns'
import { DataTable } from '@/components/ui/DataTable'

export const WorkspaceFilesPage = () => {
  return (
    <>
      <WorkspacesBreadcrumbs title="Files" />
      <QueryErrorBoundary errorMessage="Failed to fetch roles">
        <Suspense fallback={<DataTableLoading />}>
          <WorkspaceFilesPageContent />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}

function WorkspaceFilesPageContent() {
  const { workspaceId } = useCurrentWorkspace()

  const { getStorageApiGetFilesDetailsWorkspace } = useRestClient()
  const { data: files } = getStorageApiGetFilesDetailsWorkspace.useSuspenseQuery({ query: { workspaceId } })

  return (
    <TablePageContainer>
      <DataTable
        columns={workspaceFilesColumns}
        data={files}
        filters={(table) => <WorkspaceFilesFilters table={table} />}
        initialColumnFilters={[{ id: 'filename', value: false }]}
      />
    </TablePageContainer>
  )
}
